import { Client, InvitedEvent, InviteEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class InviteEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.INVITED, (event: InvitedEvent) => {
            const { nick, channel, time, tags } = event;
            this.mH.addMessage(this.tM.getActiveTab(), `* ${nick} has been invited to ${channel}`, IRCMessageType.SYSTEM);
        });

        this.client.on(IRC_EVENT.INVITE, (event: InviteEvent) => {
            const { nick, ident, hostname, invited, channel, time, tags } = event;
            let targetTab = this.tM.getTab(tabType.QUERY, channel);
            if (!targetTab) {
                targetTab = this.tM.getActiveTab();
            }

            if (invited === this.client.user.nick) {
                this.mH.addMessage(targetTab, `* ${nick} (${ident}@${hostname}) invites you to join ${channel}. Type <b>/join ${channel}</b> to join.`, IRCMessageType.SYSTEM);
            } else {
                this.mH.addMessage(targetTab, `* ${nick} (${ident}@${hostname}) has invited ${invited} to ${channel}`, IRCMessageType.SYSTEM);
            }

        });
    }
}